<template>
  <v-card v-if="user">
    <v-card-title>
      My Profile
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12"
               sm="3">
          <div>
            Name
          </div>
          {{ user.full_name }}
        </v-col>

        <v-col cols="12"
               sm="3">
          <div>
            Email
          </div>
          {{ user.email }}
        </v-col>

        <v-col cols="12"
               sm="3">
          <div>
            Phone
          </div>
          {{ user.phone }}
        </v-col>

        <v-col cols="12"
               sm="3">
          <div>
            Phone Extension
          </div>
          {{ user.phone_extension }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12"
               sm="3">
          <div>
            Title
          </div>
          {{ user.title }}
        </v-col>

        <v-col cols="12"
               sm="3">
          <div>
            Language
          </div>
          {{ user.locale_name }}
        </v-col>

        <v-col cols="12"
               sm="3">
          <div>
            Time Zone
          </div>
          {{ user.timezone }}
        </v-col>

      </v-row>

      <v-row>
        <v-col cols="12"
               sm="3">
          <div>
            Division
          </div>
          {{ user.division ? user.division : 'Not set' }}
        </v-col>

        <v-col cols="12"
               sm="3">
          <div>
            Department
          </div>
          {{ user.department ? user.department : 'Not set' }}
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12"
               sm="3">
          <div>
            Region
          </div>
          {{ user.region ? user.region : 'Not set' }}
        </v-col>

        <v-col cols="12"
               sm="3">
          <div>
            District
          </div>
          {{ user.district ? user.district : 'Not set' }}
        </v-col>

        <v-col cols="12"
               sm="3">
          <div>
            Territory
          </div>
          {{ user.territory ? user.territory : 'Not set' }}
        </v-col>
      </v-row>

      <v-row v-if="team.use_crm_mailbox && user.crm_mailbox">
        <v-col cols="12">
          <div>
            {{ crmMailboxLabel }}
          </div>
          <a :href="`mailto:${user.crm_mailbox}`">{{ user.crm_mailbox }}</a>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn :to="{name: 'library.edit_profile'}"
             color="primary"
             block>
        Edit Profile
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  computed: {
    ...mapGetters([
      'crmMailboxLabel',
      'team',
      'user',
    ]),
  },
}
</script>
